module.exports = __webpack_public_path__ + "static/media/KC.aa73cfd0.png";